var SirvOptions = {autostart: !1}, $lockMZUpdate = !1, $firstImageIsVideo = !1;
mzOptions = mzOptions || {};
var mtZoomIsReady = !(mzOptions.onUpdate = function () {
    $lockMZUpdate || mtHighlightActiveSelector();
    $lockMZUpdate = !1
});
mzOptions.onZoomReady = function (id) {
    mtZoomIsReady = !0;
    $firstImageIsVideo || mtHighlightActiveSelector()
};

function mtIfZoomReady(fnc) {
    mtZoomIsReady ? fnc() : setTimeout(function () {
        mtIfZoomReady(fnc)
    }, 250)
}

function mtInitSelectors(selector) {
    jQuery(selector).on("click", function (e) {
        var el = jQuery(this);
        if ("spin" == el.attr("data-slide-id")) {
            var spinObj = document.getElementById("sirv-spin");
            Sirv.exists(spinObj) || Sirv.start(spinObj)
        }
        jQuery(".MagicToolboxContainer .MagicToolboxSlide").removeClass("active-magic-slide");
        jQuery('.MagicToolboxContainer .MagicToolboxSlide[data-slide-id="' + el.attr("data-slide-id") + '"]').addClass("active-magic-slide");
        jQuery(".MagicToolboxContainer .MagicToolboxSelectorsContainer a").removeClass("active-magic-selector mz-thumb-selected");
        el.addClass("active-magic-selector mz-thumb-selected");
        e.preventDefault()
    })
}

function mtInitVideoSelectors() {
    jQuery(".MagicToolboxSlides div[data-video-url]").each(function () {
        var video_id, video_type,
            m = /https?:\/\/youtu\.be\/([^\/]{1,})\/?/gm.exec(jQuery(this).attr("data-video-url"));
        if (m) {
            video_id = m[1];
            video_type = "youtube"
        } else if (m = /https?:\/\/www\.youtube\.com\/watch\?v=(.{1,})/gm.exec(jQuery(this).attr("data-video-url"))) {
            video_id = m[1];
            video_type = "youtube"
        } else if (m = /https?:\/\/vimeo\.com\/(.{1,})/gm.exec(jQuery(this).attr("data-video-url"))) {
            video_id = m[1];
            video_type = "vimeo"
        }
        "youtube" == video_type ? jQuery(this).html('<div class="magic-video-container"><iframe src="https://www.youtube.com/embed/' + video_id + '" frameborder="0" allowfullscreen></iframe></div>') : "vimeo" == video_type ? jQuery(this).html('<div class="magic-video-container"><iframe src="https://player.vimeo.com/video/' + video_id + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>') : jQuery('div[data-slide-id="' + jQuery(this).attr("data-slide-id") + '"],a[data-slide-id="' + jQuery(this).attr("data-slide-id") + '"]').remove()
    })
}

function mtHighlightActiveSelector() {
    jQuery(".MagicToolboxContainer .MagicToolboxSelectorsContainer a").removeClass("active-magic-selector");
    jQuery(".MagicToolboxContainer .MagicToolboxSelectorsContainer a.mz-thumb-selected").addClass("active-magic-selector")
}

function mtGetMaxSizes() {
    var $maxWidth = $maxHeight = 1;
    jQuery(".MagicToolboxSelectorsContainer a > img").each(function () {
        var img = jQuery(this);
        if (img.is(":visible")) {
            $maxHeight = Math.max($maxHeight, img.height());
            $maxWidth = Math.max($maxWidth, img.width())
        }
    });
    return {width: $maxWidth, height: $maxHeight}
}

function mtInitSirv() {
    if ("undefined" != typeof SirvID && "" != SirvID) {
        var sirv = document.createElement("script");
        sirv.type = "text/javascript";
        sirv.async = !0;
        sirv.src = document.location.protocol.replace("file:", "http:") + "//scripts.sirv.com/sirv.js";
        document.getElementsByTagName("script")[0].parentNode.appendChild(sirv);
        var spinURL = document.location.protocol.replace("file:", "https:") + "//" + SirvID + ".sirv.com/" + SirvSpinsPath.replace(/{product\-id}/g, SirvProductID);
        jQuery.ajax({
            url: spinURL,
            dataType: "jsonp",
            cache: !0,
            timeout: 4e3,
            error: function (jqXHR, textStatus, errorThrown) {
                initMagicScroll()
            },
            success: function (data, textStatus, jqXHR) {
                mtInitSirvIcon(spinURL)
            }
        });
        for (var i in SirvVariants) {
            var v_spinURL = document.location.protocol.replace("file:", "http:") + "//" + SirvID + ".sirv.com/" + SirvSpinsPath.replace(/{product\-id}/g, SirvProductID + "-" + i);
            jQuery.ajax({
                url: v_spinURL,
                dataType: "jsonp",
                cache: "false",
                timeout: 4e3,
                spinID: i,
                error: function () {
                    SirvVariants[this.spinID] = !1
                },
                success: function (data) {
                    SirvVariants[this.spinID] = this.url.replace(/\?callback.*/gm, "")
                }
            })
        }
    } else initMagicScroll()
}

function initMagicScroll() {
    jQuery("#msc-selectors-container").length && MagicScroll.start()
}

function mtInitArrows() {
    jQuery(".MagicToolboxSlides .MagicToolboxSlides-arrow").on("click touchstart", function (e) {
        var $mscItem, $mscCurItemId, $mscNewItemId,
            $selectorsContainer = jQuery(".MagicToolboxContainer .MagicToolboxSelectorsContainer"),
            $currentSelector = $selectorsContainer.find("a.active-magic-selector"), $newSelector = !1,
            $useScroll = jQuery("#msc-selectors-container").length, $forward = jQuery(this).hasClass("next");
        if ($useScroll) {
            $mscCurItemId = ($mscItem = $currentSelector.parent()).attr("data-item");
            if (!($mscItem = $forward ? $mscItem.next() : $mscItem.prev()).length) {
                $mscItem = $selectorsContainer.find("div[data-item=" + $mscCurItemId + "]");
                if (!($mscItem = $forward ? $mscItem.first().next() : $mscItem.last().prev()).length && !($mscItem = $forward ? $selectorsContainer.find(".mcs-item:first") : $selectorsContainer.find(".mcs-item:last")).length) {
                    e.preventDefault();
                    return
                }
            }
            $newSelector = $mscItem.find("a");
            $mscNewItemId = $mscItem.attr("data-item");
            $mscNewItemId = parseInt($mscNewItemId, 10);
            MagicScroll.jump("msc-selectors-container", $mscNewItemId)
        } else ($newSelector = $forward ? $currentSelector.next("a") : $currentSelector.prev("a")).length || ($newSelector = $forward ? $selectorsContainer.find("a:first") : $selectorsContainer.find("a:last"));
        if ($newSelector.length) {
            $newSelector.trigger("click");
            if ($newSelector.hasClass("mz-thumb")) {
                $lockMZUpdate = !0;
                MagicZoom.switchTo(jQuery("a.MagicZoomPlus").attr("id"), $newSelector[0])
            }
        }
        e.preventDefault()
    })
}

function mtInitVariants() {
    if (window.slate && slate.Variants && slate.Variants.prototype._updateImages) {
        slate.Variants.prototype._updateImagesOriginal = slate.Variants.prototype._updateImages;
        slate.Variants.prototype._updateImages = function (variant) {
            var variantImage = variant.featured_image || {},
                currentVariantImage = this.currentVariant.featured_image || {};
            if (void 0 !== SirvVariants[variant.id] && "string" == typeof SirvVariants[variant.id]) mtShowSirvVariant(variant.id); else {
                if (!variant.featured_image || variantImage.src === currentVariantImage.src) return;
                var largeImage = variantImage.src,
                    iSize = theme.Images.imageSize(jQuery("a.MagicZoomPlus img").first().attr("src")),
                    smallImage = theme.Images.getSizedImageUrl(largeImage, iSize);
                variantImage.product_id == SirvProductID && mtIfZoomReady(function () {
                    mtSwitchImage(largeImage, smallImage)
                })
            }
            return this._updateImagesOriginal.apply(this, arguments)
        }
    }
    if (Shopify.OptionSelectors && Shopify.OptionSelectors.prototype.updateSelectors) {
        Shopify.OptionSelectors.prototype.updateSelectorsOriginal = Shopify.OptionSelectors.prototype.updateSelectors;
        Shopify.OptionSelectors.prototype.updateSelectors = function (index, option) {
            var values = this.selectedValues(), variant = this.product.getVariant(values);
            if (variant) if ("undefined" != typeof SirvVariants && void 0 !== SirvVariants[variant.id] && "string" == typeof SirvVariants[variant.id]) mtShowSirvVariant(variant.id); else {
                var featuredImage = variant.featured_image;
                if (featuredImage) {
                    var largeImage = featuredImage.src,
                        iSize = Shopify.Image.imageSize(jQuery("a.MagicZoomPlus img").first().attr("src")),
                        smallImage = Shopify.Image.getSizedImageUrl(largeImage, iSize);
                    featuredImage.product_id == SirvProductID && mtIfZoomReady(function () {
                        mtSwitchImage(largeImage, smallImage)
                    })
                }
            }
            return this.updateSelectorsOriginal.apply(this, arguments)
        }
    }
}

function mtInitSirvIcon(spinURL) {
    jQuery(".MagicToolboxSlides").append('<div data-slide-id="spin" class="MagicToolboxSlide"><div class="Sirv" id="sirv-spin" data-src="' + spinURL + '"></div></div>');
    jQuery(".MagicToolboxContainer").removeClass("no-thumbnails");
    jQuery(".MagicToolboxSelectorsContainer").show();
    jQuery(".MagicToolboxSlides .MagicToolboxSlides-arrow").show();
    var sizes = mtGetMaxSizes();
    jQuery(".MagicToolboxSelectorsContainer a:last").after(' <a data-slide-id="spin" href="#"><img id="SirvIcon" style="display:none;" src="' + SirvIconURL + '"/></a>');
    jQuery(".MagicToolboxContainer").hasClass("layout-bottom") ? jQuery("#SirvIcon").css("height", sizes.height + "px").show() : jQuery("#SirvIcon").css("width", sizes.width + "px").show();
    mtInitSelectors('.MagicToolboxSelectorsContainer a[data-slide-id="spin"]');
    initMagicScroll()
}

function mtShowSirvVariant(variant_id) {
    if (0 == jQuery("#SirvIcon").length) {
        jQuery("#msc-selectors-container").length && MagicScroll.stop();
        mtInitSirvIcon(SirvVariants[variant_id])
    }
    "undefined" != typeof Sirv && Sirv.stop();
    jQuery('div[data-slide-id="spin"]').html('<div class="Sirv" id="sirv-spin" data-src="' + SirvVariants[variant_id] + '"></div>');
    jQuery('a[data-slide-id="spin"]').trigger("click")
}

function mtSwitchImage(largeImage, smallImage) {
    var activeSlide = jQuery(".MagicToolboxContainer .active-magic-slide");
    if ("spin" == activeSlide.attr("data-slide-id")) {
        activeSlide.removeClass("active-magic-slide");
        jQuery('.MagicToolboxContainer .MagicToolboxSlide[data-slide-id="zoom"]').addClass("active-magic-slide")
    }
    if (0 == jQuery(".mz-lens").length) {
        mtHighlightActiveSelector();
        jQuery("a.MagicZoomPlus").attr("href", largeImage);
        jQuery("a.MagicZoomPlus img").first().attr("src", smallImage)
    } else MagicZoom.update(jQuery("a.MagicZoomPlus").attr("id"), largeImage, smallImage)
}

function mtOnDomReady(fnc) {
    "undefined" != typeof jQuery ? jQuery(document).ready(fnc) : setTimeout(function () {
        mtOnDomReady(fnc)
    }, 250)
}

mtOnDomReady(function () {
    jQuery("#admin_bar_iframe").length && jQuery(document.body).append('<style type="text/css">.mz-zoom-window { margin-top: -' + jQuery("#admin_bar_iframe").height() + "px; </style>");
    mtInitVideoSelectors(".MagicToolboxSelectorsContainer a");
    mtInitSelectors(".MagicToolboxSelectorsContainer a");
    var $firstVideoSelector = jQuery('[data-slide-num="0"][data-video-url]');
    if ($firstVideoSelector.length) {
        jQuery('a[data-slide-id="' + $firstVideoSelector.attr("data-slide-id") + '"]').trigger("click");
        $firstImageIsVideo = !0
    }
    mtInitSirv();
    mtInitArrows();
    mtInitVariants();
    jQuery(".MagicZoomPlus").attr("onmouseout", "MagicZoom.zoomOut('zoom" + SirvProductID + "')")
});
